import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import Vuetify from "vuetify";
import VuetifyLib from "vuetify/lib";
import AsyncComputed from "vue-async-computed";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
import VueRouter from "vue-router";
import axios from "axios";
import Fragment from "vue-fragment";
import { publicDico } from "./assets/dico/publicDico";
import { privateDico } from "./assets/dico/privateDico";
import MainContainer from "src/components/common/main-container/MainContainer.vue";
import Action from "./components/common/action/Action.vue";
import Typo from "./components/common/typo/Typo.vue";
import Sep from "./components/common/sep/Sep.vue";
import Breadcrumb from "./components/common/breadcrumb/Breadcrumb.vue";
import theme from "src/theme/vuetify";

Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(AsyncComputed);
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(Fragment.Plugin);

Vue.config.productionTip = false;
Vue.prototype.$publicDico = publicDico;
Vue.prototype.$privateDico = privateDico;

Vue.component("MainContainer", MainContainer);
Vue.component("Action", Action);
Vue.component("Typo", Typo);
Vue.component("Sep", Sep);
Vue.component("Breadcrumb", Breadcrumb);
Vue.filter("printf", function (value, param) {
    if (!value) return "";
    return value.replace("%s", param);
});

new Vue({
    router,
    vuetify: new VuetifyLib({ theme }),
    render: h => h(App),
}).$mount("#app");
